import { API_URL } from "../config/connect";

// Decode JWT payload without signature verification — the backend still
// validates the token when we hit /admin/get-user-role. We only need `email`
// locally to build the URL. Works for both Google ID tokens and our own
// long-lived admin-session tokens (both have `email` in the payload).
function decodeJwtEmail(token) {
    try {
        const parts = token.split(".");
        if (parts.length !== 3) return null;
        const payload = JSON.parse(
            atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"))
        );
        return payload.email || null;
    } catch {
        return null;
    }
}

const getRole = async () => {
    const token = localStorage.getItem("google_id_token");

    if (!token) {
        throw new Error("No token found. User is not signed in.");
    }

    const email = decodeJwtEmail(token);
    if (!email) {
        throw new Error("Invalid token: Email not found.");
    }

    const endpoint = `${API_URL}/api/v1/admin/get-user-role/${email}`;

    const response = await fetch(endpoint, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch role. Status: ${response.status}`);
    }

    const data = await response.json();
    if (!data || !data.role) {
        throw new Error("Role data not found in response.");
    }
    return data.role;
};

export default getRole;
